import * as types from "./actionTypes";

export const setPecanAssessmentLoading = (isLoading) => {
  return {
    type: types.PECAN_ASSESSMENT_IS_LOADING,
    payload: isLoading,
  };
};

export const submitPecanAssessment = (testAnswers) => ({
  type: types.SUBMIT_PECAN_ASSESSMENT,
  payload: { testAnswers },
});

export const postPecanForms = (formName, formContent) => ({
  type: types.POST_PECAN_FORMS,
  payload: { formName, formContent },
});

export const markDocumentReadPecan = (documentFilename) => ({
  type: types.MARK_DOCUMENT_READ_PECAN,
  payload: documentFilename,
});

export const setPecanReadingLoading = (isLoading) => {
  return {
    type: types.SET_PECAN_READING_LOADING,
    payload: isLoading,
  };
};

export const submitPecanForms = (content) => ({
  type: types.SUBMIT_PECAN_FORMS,
  payload: { content },
});

export const submitPecanFormsSuccess = () => ({
  type: types.SUBMIT_PECAN_FORMS_SUCCESS,
});

export const submitPecanAssessmentSuccess = (total) => ({
  type: types.SUBMIT_PECAN_ASSESSMENT_SUCCESS,
  payload: { total },
});
